import { getOutboundMessage } from './outboundUtils';
export function createPokerChatOutbound(message) {
    return getOutboundMessage({ _type: 'c', parts: [{ name: 'message', stringValue: message }] });
}
export function createExitPokerRoomToLoungeOutbound(loungeId = 0) {
    return getOutboundMessage({
        _type: 'lounge',
        parts: [{ name: 'loungeId', numberValue: loungeId }]
    });
}
function createBetActionOutbound(betSequenceNumber, outboundBetActionType, betAmount) {
    return getOutboundMessage({
        _type: 'bet',
        parts: [
            { name: 'betSequenceNumber', numberValue: betSequenceNumber },
            { name: 'outboundBetActionType', stringValue: outboundBetActionType },
            { name: 'betAmount', numberValue: betAmount !== undefined ? betAmount : -1 },
            { name: 'clientTimeMs', numberValue: -1 } // related to tracking lag via bet packets (optional on server)
        ]
    });
}
export function createFoldOutbound(betSequenceNumber) {
    return createBetActionOutbound(betSequenceNumber, 'fold');
}
export function createCallOutbound(betSequenceNumber) {
    return createBetActionOutbound(betSequenceNumber, 'call');
}
export function createCheckOutbound(betSequenceNumber) {
    return createBetActionOutbound(betSequenceNumber, 'check');
}
export function createBetOutbound(betSequenceNumber, betAmount) {
    return createBetActionOutbound(betSequenceNumber, 'bet', betAmount);
}
export function createRaiseOutbound(betSequenceNumber, betAmount) {
    return createBetActionOutbound(betSequenceNumber, 'raise', betAmount);
}
export function createAllInOutbound(betSequenceNumber) {
    return createBetActionOutbound(betSequenceNumber, 'all_in');
}
export function createSitOutbound(seatIndex) {
    return getOutboundMessage({
        _type: 's',
        parts: [
            { name: 'seatIndex', numberValue: seatIndex },
            { name: 'isConfirmed', booleanValue: false }
        ]
    });
}
export function createSitWithBuyInOutbound(seatIndex, requestedBuyIn) {
    return getOutboundMessage({
        _type: 'sit_with_buyin',
        parts: [
            { name: 'seatIndex', numberValue: seatIndex },
            { name: 'isConfirmed', booleanValue: true },
            { name: 'requestedBuyIn', numberValue: requestedBuyIn }
        ]
    });
}
export function createSetBuyInOutbound(requestedBuyIn) {
    return getOutboundMessage({
        _type: 'set_buyin',
        parts: [{ name: 'requestedBuyIn', numberValue: requestedBuyIn }]
    });
}
export function createStandUpOutbound() {
    return getOutboundMessage({ _type: 'su' });
}
export function createInitGameOutbound() {
    return getOutboundMessage({ _type: 'init_game' });
}
export function createStartTourneyOutbound() {
    return getOutboundMessage({ _type: 'start_tourney' });
}
export function createSitOutOutbound() {
    return getOutboundMessage({ _type: 'sitout' });
}
export function createSitInOutbound() {
    return getOutboundMessage({ _type: 'sitin' });
}
export function createSetAvatarOutbound(avatarPropertiesSet) {
    return getOutboundMessage({
        _type: 'set_avatar',
        parts: [{ name: 'avatarJson', stringValue: JSON.stringify(avatarPropertiesSet), needsEncoding: true }]
    });
}
export function createLegacySetAvatarNumberOutbound(legacyAvatarNumber) {
    return getOutboundMessage({
        _type: 'pf',
        parts: [
            { name: 'legacyAvatarNumber', numberValue: legacyAvatarNumber },
            { name: 'legacyAvatarRgbNumber', numberValue: 16763955 }, // default color
            { name: 'legacyAvatarVariationNumber', numberValue: 1 }
        ]
    });
}
export function createThrowBombOutbound(targetUsername, bombType, numberOfBombs = 1) {
    return getOutboundMessage({
        _type: 'bomb',
        parts: [
            { name: 'bombName', stringValue: bombType },
            { name: 'targetUsername', stringValue: targetUsername },
            { name: 'numberOfBombs', numberValue: numberOfBombs }
        ]
    });
}
export function createDiscardOutbound(cardIndex) {
    return getOutboundMessage({
        _type: 'discard',
        parts: [{ name: 'cardIndex', numberValue: cardIndex }]
    });
}
export function createToggleRevealHandOutbound(isRevealingThisHand, activeHandId) {
    return getOutboundMessage({
        _type: 'toggle_reveal',
        parts: [
            { name: 'isRevealingThisHand', booleanValue: isRevealingThisHand },
            { name: 'activeHandId', numberValue: activeHandId }
        ]
    });
}
export function createSetThemeBackgroundOutbound(themeType, themeBackgroundType) {
    return getOutboundMessage({
        _type: 'set_theme_background',
        parts: [
            { name: 'themeType', stringValue: themeType },
            { name: 'themeBackgroundType', stringValue: themeBackgroundType, needsEncoding: true }
        ]
    });
}
export function createSetThemeTableOutbound(themeType, themeTableType) {
    return getOutboundMessage({
        _type: 'set_theme_table',
        parts: [
            { name: 'themeType', stringValue: themeType },
            { name: 'themeTableType', stringValue: themeTableType, needsEncoding: true }
        ]
    });
}
export function createSideBetOutbound(playerId) {
    return getOutboundMessage({
        _type: 'side_bet',
        parts: [{ name: 'playerId', numberValue: playerId }]
    });
}
